var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":"","label":""}},[_c('v-icon',{staticClass:"mr-1",attrs:{"color":_vm.type},domProps:{"innerHTML":_vm._s(_vm.type)}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }